import l from "./index.es243.js";
function s(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = u(e)) || r) {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u(e, r) {
  if (e) {
    if (typeof e == "string") return a(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? a(e, r) : void 0;
  }
}
function a(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function c(e) {
  var r = '<?xml version="1.0"?>';
  r += '<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';
  for (var t = s(e), n; !(n = t()).done; ) {
    var o = n.value, i = o.trim().length === o.length ? "" : ' xml:space="preserve"';
    r += "<si><t".concat(i, ">"), r += l(o), r += "</t></si>";
  }
  return r += "</sst>", r;
}
export {
  c as default
};
//# sourceMappingURL=index.es216.js.map
